
import * as z from "zod";
import { UserRole } from "@/hooks/useUserRoles";

export const userSchema = z.object({
  name: z.string().min(2, { message: "Nome deve ter pelo menos 2 caracteres" }),
  email: z.string().email({ message: "Email inválido" }),
  password: z.string().min(8, { message: "Senha deve ter pelo menos 8 caracteres" }),
  role: z.enum(["admin", "support", "marketing", "integrations_manager"] as const),
  sendWelcomeEmail: z.boolean().default(true),
});

export type UserFormValues = z.infer<typeof userSchema>;
